import { helper } from '@ember/component/helper';
import { formatPeriodRange } from 'linced-app/utils/reporting';

// Renders a reporting period's date range from the backend-resolved bounds on
// the counts entry, e.g.
// {{reporting/period-range drafts.periodStartDate drafts.periodEndDate}}.
// See formatPeriodRange for the format.
export default helper(function periodRange([startDate, endDate]) {
  return formatPeriodRange(startDate, endDate);
});
